function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M0.75 0.25C0.335786 0.25 0 0.585786 0 1C0 1.41421 0.335786 1.75 0.75 1.75H2.75C3.44036 1.75 4 2.30964 4 3V12C4 14.2091 5.79086 16 8 16H16C18.2091 16 20 14.2091 20 12V7C20 4.79086 18.2091 3 16 3H5.5C5.5 1.48122 4.26878 0.25 2.75 0.25H0.75ZM15.6533 10.6317C15.8567 10.9925 15.7292 11.4499 15.3683 11.6533C14.1532 12.3384 13.1065 12.7479 12.0028 12.75C10.8978 12.7521 9.8491 12.3459 8.62915 11.6519C8.26912 11.4471 8.14329 10.9892 8.3481 10.6292C8.55292 10.2691 9.01082 10.1433 9.37085 10.3481C10.507 10.9945 11.2821 11.2514 11.9999 11.25C12.7191 11.2486 13.4944 10.9879 14.6317 10.3467C14.9925 10.1433 15.4499 10.2708 15.6533 10.6317Z"
});

var _ref3 =
/*#__PURE__*/
React.createElement("path", {
  d: "M7.5 21C8.32843 21 9 20.3284 9 19.5C9 18.6716 8.32843 18 7.5 18C6.67157 18 6 18.6716 6 19.5C6 20.3284 6.67157 21 7.5 21Z"
});

var _ref4 =
/*#__PURE__*/
React.createElement("path", {
  d: "M18 19.5C18 20.3284 17.3284 21 16.5 21C15.6716 21 15 20.3284 15 19.5C15 18.6716 15.6716 18 16.5 18C17.3284 18 18 18.6716 18 19.5Z"
});

var SvgShoppingCartFill = function SvgShoppingCartFill(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return React.createElement("svg", _extends({
    width: 20,
    height: 21,
    viewBox: "0 0 20 21",
    fill: "none",
    ref: svgRef
  }, props), React.createElement("title", null, title), _ref2, _ref3, _ref4);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgShoppingCartFill, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/shopping-cart-fill.6f1ee0a8.svg";
export { ForwardRef as ReactComponent };